import React from "react";

import { TableCell, TableRow } from "@mui/material";
import clsx from "clsx";

import mainStyles from "../../../styles";

export const UserFieldsTableHeader = () => {
  const classes = mainStyles();
  return (
    <TableRow data-testid="user-field-table-header">
      <TableCell className={clsx(classes.tableCell)} align="center">
        Name
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Description
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Data Type
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        Options
      </TableCell>
      <TableCell className={clsx(classes.tableCell)} align="center">
        In Use
      </TableCell>
    </TableRow>
  );
};
